(() => {
  const root = document.querySelector('[data-sb-show-thanks]');
  if (!root) return;

  const query = new URLSearchParams(window.location.search);
  const isKiosk = query.get('kiosk') === '1';
  const previewKeys = ['preview_theme_id', 'preview_token', '_fd', 'pb', 'view'];
  const cleanQuery = new URLSearchParams();

  if (isKiosk) cleanQuery.set('kiosk', '1');
  previewKeys.forEach((key) => {
    if (query.has(key)) cleanQuery.set(key, query.get(key));
  });

  const cleanQueryString = cleanQuery.toString();
  const cleanUrl = `${window.location.pathname}${cleanQueryString ? `?${cleanQueryString}` : ''}`;

  if (`${window.location.pathname}${window.location.search}${window.location.hash}` !== cleanUrl) {
    window.history.replaceState({}, '', cleanUrl);
  }

  root.dataset.sbShowThanksKiosk = isKiosk ? 'true' : 'false';
  if (!isKiosk) return;

  root.querySelectorAll('[data-sb-thanks-kiosk-only]').forEach((element) => {
    element.hidden = false;
  });

  const output = root.querySelector('[data-sb-show-countdown]');
  const pauseButton = root.querySelector('[data-sb-show-pause]');
  const returnQuery = new URLSearchParams();
  previewKeys.forEach((key) => {
    if (query.has(key)) returnQuery.set(key, query.get(key));
  });
  const returnPath = root.dataset.sbReturnUrl || '/show';
  const returnQueryString = returnQuery.toString();
  const returnUrl = `${returnPath}${returnQueryString ? `?${returnQueryString}` : ''}`;
  const configuredSeconds = Number.parseInt(root.dataset.sbReturnSeconds, 10);
  let remaining = Number.isFinite(configuredSeconds) ? configuredSeconds : 11;
  let paused = false;

  const announce = () => {
    if (!output) return;
    output.textContent = paused
      ? 'Automatic return is paused.'
      : `Returning to the show form in ${remaining} second${remaining === 1 ? '' : 's'}.`;
  };

  const timer = window.setInterval(() => {
    if (paused) return;

    remaining -= 1;
    if (remaining <= 0) {
      window.clearInterval(timer);
      window.location.replace(returnUrl);
      return;
    }

    announce();
  }, 1000);

  pauseButton?.addEventListener('click', () => {
    paused = !paused;
    pauseButton.textContent = paused ? 'Resume return' : 'Pause return';
    announce();
  });

  announce();
})();
